import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconTextNew = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M28.937 17.999h2.691l2.245-7.919 2.262 7.919h2.691l3.359-11.998h-2.485l-2.297 8.896-2.52-8.896h-2.022l-2.502 8.896-2.297-8.896h-2.485l3.36 11.998z M19.711 13.045v2.691h5.056v2.262h-7.422v-11.998h7.336v2.262h-4.971v2.554h4.542v2.228h-4.542z M12.755 13.32v-7.319h2.365v11.998h-1.8l-5.142-7.336v7.336h-2.365v-11.998h1.8l5.142 7.319z" }),
    width: 48,
});

export { IconTextNew };
